import * as StM from '../../models/store';
import BaseReducer from '../baseReducer';
import * as _ from 'lodash';

export default class EditSubscriptionDialogReducer extends BaseReducer {
    static handle(state: StM.IEditSubscriptionDialogStoreState = new StM.EditSubscriptionDialogStoreState(), action: any): StM.IEditSubscriptionDialogStoreState {
        switch (action.type) {
            case 'Dialogs/Admin/EditSubscription/Open': {
                return <StM.IEditSubscriptionDialogStoreState>_.assign({}, state, { isOpened: true, id: action.id });
            }
            case 'Dialogs/Admin/EditSubscription/Close': {
                return <StM.IEditSubscriptionDialogStoreState>_.assign({}, state, { isOpened: false });
            }
            default: {
                return state;
            }
        }
    }
}
